<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Mike was born on 26 March 1950 at Strathfield, Sydney, Australia. His mother pretended marriage; his father had died nine months earlier. Mike is an only child. When Mike was eight, his mother died. His aunt adopted him and moved him to Wollongong, fifty miles south of Sydney. She was single, childless and a headmistress at an infant school.</p>
<p>Back in Sydney, Mike worked for years in the Australian government Department of Defence, mainly as a civilian analyst of Navy Air Force battle exercises. He retired in 2005. He is single and lives with Tom, his cat.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?2fc5739c